class Observable {
    _listners;
    constructor() {
        this._listners = {};
    }
    on(event, listener) {
        if (!this._listners[event]) {
            this._listners[event] = new Set();
        }
        this._listners[event].add(listener);
        return () => this._listners[event].delete(listener);
    }
    emit(event, ...args) {
        if (!this._listners[event]) {
            return;
        }
        this._listners[event].forEach((cb) => cb(...args));
    }
}
export default Observable;
